export default __webpack_public_path__ + "static/media/icon-refresh.8ded5eae.svg";